// extracted by mini-css-extract-plugin
export default {"input__container":"styles_input__container__y8fSZ","input__label":"styles_input__label__3iPq2","input__box":"styles_input__box__9dX1Z"};